import cn from 'classnames';
import * as React from 'react';
import mursionLogo from './images/mursion-logo.svg';
import styles from './Login.css';
import config from './config.json';
import LoginForm from 'src/layouts/unauthorized/Login/LoginForm';
import TranslateMessage from 'src/i18n/TranslateMessage';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import UnauthorizedCarousel from "src/components/SlickCarousel/UnauthorizedCarousel";
import TOTPAuthentication from 'src/layouts/common/TOTPAuthentication/TOTPAuthentication';

export interface ILoginProps {
  enableToEditForm: boolean;
  error?: string;
  redirectUrl?: string;
  isTOTPAuthentication?: boolean;
  onVerificationOTP?: (isTOTPVerificationRequired: boolean) => void;
}

class Login extends React.Component <ILoginProps & WrappedComponentProps> {

  public intervalID:ReturnType<typeof setTimeout>;
  constructor(props:any){
    super(props);
  
  }

  public render() {
    const { enableToEditForm, error, redirectUrl, isTOTPAuthentication = false, onVerificationOTP } = this.props;
    const { intl } = this.props;
    const PORTAL_HEADING = 'MursionPortal.Message.PortalHeading';
    const PORTAL_TEXT = 'MursionPortal.Message.PortalHeadingText';

    return (
      <>
        <header role="banner">
          <label className="visibilityHidden">{intl.formatMessage({ id: 'MursionPortal.VisibilityHidden.Header' })}</label>
        </header>
        <main role="main" className={styles.container}>
          {/*Left*/}
          <div className={cn(styles.posRel, styles.sideL)}>
            <UnauthorizedCarousel />
          </div>                    
          
          {/*[End] Left*/}


          {/*Right*/}
          <div className={cn(styles.posRel, styles.sideR)}>

            <div className={cn(styles.inner, styles.loginFormContainer)}>
              <div>
              <img className={styles.mursionLogo} src={mursionLogo}
                  alt={intl.formatMessage({ id: 'MursionPortal.AltText.MursionDashboard' })} aria-hidden="true"/>
                  <div className={styles.mursionText}>{intl.formatMessage({ id: 'MursionPortal.AltText.MursionPortal' })}</div>
                  <div className={styles.portalText}>
                    <p> {TranslateMessage(PORTAL_HEADING)} <br/>{TranslateMessage(PORTAL_TEXT)} </p>
                  </div>
              </div>
              <div><h2 className={styles.formHeader}>{TranslateMessage('Login.SignIn')}</h2></div>
              {
                isTOTPAuthentication ?
                  <TOTPAuthentication onVerificationOTP={onVerificationOTP} />
                  :
                  <LoginForm
                    enableToEditForm={enableToEditForm}
                    error={error}
                    redirectUrl={redirectUrl}
                  />
              }

            </div>
            <ul className={cn(styles.footer, styles.footerNav)}>
              <li><a href={config.homePage.url} style={{ marginLeft: 0 }}>{config.homePage.label}</a></li>
              <li><a href={config.support.url}
                     style={{ marginRight: 0 }}>{TranslateMessage('Login.TechnicalSupport')}</a></li>
              <li><a href={config.privacyPolicy.url}>{TranslateMessage('Login.PrivacyPolicy')}</a></li>
              <li><a href={config.privacyInfo.url}>{TranslateMessage('Login.PrivacyDataInfo')}</a></li>
            </ul>
          </div>
          {/*[End] Right*/}


          {/*Mursion mark logo image*/}
          {/* <img className={styles.mursionMark} src={logo} alt={intl.formatMessage({ id: 'Login.Image' })} aria-hidden="true"/> */}


        </main>
        <footer role="contentinfo">
          <label className="visibilityHidden">{intl.formatMessage({ id: 'MursionPortal.VisibilityHidden.Footer' })}</label>
        </footer>
      </>
    );
  }
}

export default injectIntl(Login);
